module.exports = function (isMobile) {
  return {
    // default fake data
    defaultPowerOptions: [{
      productId: '6757458116681',
      variantId: [],
      tag: 'Recommended',
      productName: '10Kwh Power Kits',
      name: 'Get Set Kit (10kWh) ',
      discountPrice: 1999,
      originalPrice: 2079,
      unit: '£',
      includes: ['10Kwh LFP Battery x1', 'Power Hub', 'Cable Pack'],
      details: {},
      img: '/img/calculators/mm100/power-2kw.jpg',
      imgH5: '/img/calculators/mm100H5/power-2kw.jpg'
    }, {
      productId: '6757463720009',
      variantId: [],
      tag: 'Delux',
      productName: '15Kwh Power Kits',
      name: 'Get Set Kit (15kWh) ',
      discountPrice: 1999,
      originalPrice: 2079,
      unit: '£',
      includes: ['15Kwh LFP Battery x1', 'Power Hub', 'Cable Pack'],
      details: {},
      img: '/img/calculators/mm100/power-2kw.jpg',
      imgH5: '/img/calculators/mm100H5/power-2kw.jpg'
    }, {
      productId: '6757464277065',
      variantId: [],
      tag: 'Regular',
      usage: 'Daily usage',
      productName: '15Kwh Power Kits',
      name: 'Get Set Kit (15kWh) ',
      discountPrice: 1999,
      originalPrice: 2079,
      unit: '£',
      includes: ['10Kwh LFP Battery x1', 'Power Hub', 'Cable Pack'],
      details: {},
      img: '/img/calculators/mm100/power-2kw.jpg',
      imgH5: '/img/calculators/mm100H5/power-2kw.jpg'
    }],
    defaultComboOptions: [{
      id: 11,
      name: 'Ultimate Combo1',
      discountPrice: 1999,
      originalPrice: 2079,
      unit: '€',
      subs: [{
        id: 110,
        name: 'Distribution Panel',
        desc: 'Die neue handliche Action-Kamera hält deine Hände frei, damit du den Moment genießen kannst',
        img: '/img/calculators/mm100/step4-panel.png',
        details: {}
      }]
    }, {
      id: 12,
      name: 'Ultimate Combo2',
      discountPrice: 1999,
      originalPrice: 2079,
      unit: '€',
      subs: [{
        id: 123,
        name: 'Distribution Panel',
        desc: 'Die neue handliche Action-Kamera hält deine Hände frei, damit du den Moment genießen kannst',
        img: '/img/calculators/mm100/step4-panel.png',
        details: {}
      }, {
        id: 124,
        name: 'Distribution Panel',
        desc: 'Die neue handliche Action-Kamera hält deine Hände frei, damit du den Moment genießen kannst',
        img: '/img/calculators/mm100/step4-panel.png',
        details: {}
      }, {
        id: 126,
        name: 'Distribution Panel',
        desc: 'Die neue handliche Action-Kamera hält deine Hände frei, damit du den Moment genießen kannst',
        img: '/img/calculators/mm100/step4-panel.png',
        details: {}
      }]
    }],
    defaultSolarOptions: [{
      id: 111,
      name: '100W Firled Grid',
      discountPrice: 1999,
      originalPrice: 2079,
      unit: '€',
      desc: 'Die neue handliche Action-Kamera hält deine Hände frei, damit du den Moment genießen kannst',
      time: '1.4 Hrs',
      img: '/img/calculators/mm100/step4-panel.png',
      details: {},
      question: {}
    }, {
      id: 112,
      name: '400W Firled Grid',
      discountPrice: 1999,
      originalPrice: 2079,
      unit: '€',
      desc: 'Die neue handliche Action-Kamera hält deine Hände frei, damit du den Moment genießen kannst',
      time: '1.4 Hrs',
      img: '/img/calculators/mm100/step4-panel.png',
      details: {},
      question: {}
    }, {
      id: 113,
      name: '150W Firled Grid',
      discountPrice: 1999,
      originalPrice: 2079,
      unit: '€',
      desc: 'Die neue handliche Action-Kamera hält deine Hände frei, damit du den Moment genießen kannst',
      time: '1.4 Hrs',
      img: '/img/calculators/mm100/step4-panel.png',
      details: {},
      question: {}
    }],
    // real data
    // power kit
    powerPack: {
      2: {
        productId: '7686916538615',
        variantId: ['42952013349111', '42952013381879', '42952013414647'],
        capacity: 2,
        productName: '2kWh Power Kits',
        name: 'Get Set Kit (2kWh) ',
        discountPrice: 3898,
        originalPrice: 4898,
        unit: '€',
        includes: ['2 kWh LFP-Batterie x1', 'Power Hub', 'Kabelpaket'],
        img: '/img/calculators/mm100/power-2kw.jpg',
        imgH5: '/img/calculators/mm100H5/power-2kw.jpg',
        detailImg: '/img/calculators/mm100/power-2kw-detail.jpg'
      },
      4: {
        productId: '7686916571383',
        variantId: ['42952013447415', '42952013480183', '42952013512951'],
        capacity: 4,
        productName: '4kWh Power Kits',
        name: 'Get Set Kit (4kWh) ',
        discountPrice: 5597,
        originalPrice: 7097,
        unit: '€',
        includes: ['2 kWh LFP-Batterie x2', 'Power Hub', 'Kabelpaket'],
        img: '/img/calculators/mm100/power-4kw.jpg',
        imgH5: '/img/calculators/mm100H5/power-4kw.jpg',
        detailImg: '/img/calculators/mm100/power-4kw-detail.jpg'
      },
      5: {
        productId: '7686916604151',
        variantId: ['42952013545719', '42952013578487', '42952013611255'],
        capacity: 5,
        productName: '5kWh Power Kits',
        name: 'Get Set Kit (5kWh) ',
        discountPrice: 5998,
        originalPrice: 7498,
        unit: '€',
        includes: ['5 kWh LFP-Batterie x1', 'Power Hub', 'Kabelpaket'],
        img: '/img/calculators/mm100/power-5kw.jpg',
        imgH5: '/img/calculators/mm100H5/power-5kw.jpg',
        detailImg: '/img/calculators/mm100/power-5kw-detail.jpg'
      },
      10: {
        productId: '7686916669687',
        variantId: ['42952013644023', '42952013676791', '42952013709559'],
        capacity: 10,
        productName: '10kWh Power Kits',
        name: 'Get Set Kit (10kWh) ',
        discountPrice: 9797,
        originalPrice: 12297,
        unit: '€',
        includes: ['5 kWh LFP-Batterie x2', 'Power Hub', 'Kabelpaket'],
        img: '/img/calculators/mm100/power-10kw.jpg',
        imgH5: '/img/calculators/mm100H5/power-10kw.jpg',
        detailImg: '/img/calculators/mm100/power-10kw-detail.jpg'
      },
      15: {
        productId: '7686916735223',
        variantId: ['42952014594295', '42952014627063', '42952014659831'],
        capacity: 15,
        productName: '15kWh Power Kits',
        name: 'Get Set Kit (15kWh) ',
        discountPrice: 13596,
        originalPrice: 17096,
        unit: '€',
        includes: ['5 kWh LFP-Batterie x3', 'Power Hub', 'Kabelpaket'],
        img: '/img/calculators/mm100/power-15kw.jpg',
        imgH5: '/img/calculators/mm100H5/power-15kw.jpg',
        detailImg: '/img/calculators/mm100/power-15kw-detail.jpg'
      }
    },
    // combo
    comboPack: [{
      productId: 1,
      variantId: '',
      name: 'Kontrollieren und visualisieren Sie Ihren Energieverbrauch.',
      discountPrice: 300,
      originalPrice: 538,
      unit: '€',
      subs: [{
        comboSubId: 'combo_1_sub_1',
        name: 'Intelligenter AC/DC-Verteilerkasten',
        desc: 'Mit 12 gesicherten DC-Anschlüssen und 6 AFCI-geschützten AC-Anschlüssen können Sie die Stromverteilung rund um Ihr Wohnmobil oder Tiny Haus verwalten. Steuern Sie bis zu 6 DC-Anschlüsse über die EcoFlow-App oder die Konsole.',
        img: '/img/calculators/mm100/combo-distribution.jpg',
        imgH5: '/img/calculators/mm100H5/combo-distribution.jpg',
        details: {
          title: 'Intelligenter AC/DC-Verteilerkasten',
          desc: 'Mit 12 gesicherten DC-Anschlüssen und 6 AFCI-geschützten AC-Anschlüssen können Sie die Stromverteilung rund um Ihr Wohnmobil oder Tiny Haus verwalten. Steuern Sie bis zu 6 DC-Anschlüsse über die EcoFlow-App oder die Konsole.',
          img: '/img/calculators/mm100/combo-detail-distribution.jpg',
          imgH5: '/img/calculators/mm100H5/combo-distribution.jpg',
          specParams: [{
            key: 'AC-Haupteingang',
            value: 'Max. 16 A, 230 V, 3600 W'
          }, {
            key: 'DC-Haupteingang',
            value: 'Max. 70 A'
          }, {
            key: 'AC-Ausgang',
            value: '6 AC-Anschlüsse, jeweils max. 10 A'
          }, {
            key: 'DC-Ausgang',
            value: '12 gesicherte DC-Anschlüsse (6 Anschlüsse über die Power Kit Konsole und App steuerbar)'
          }, {
            key: 'Betriebstemperatur',
            value: '-25°C to 60°C'
          }, {
            key: 'Abmessungen',
            value: '210 x 354 x 98 mm (Höhe x Breite x Tiefe)'
          }, {
            key: 'Nettogewicht',
            value: '2,6 kg'
          }, {
            key: 'Schutzart',
            value: 'IP21'
          }, {
            key: 'Tests und Zertifikationen',
            value: 'CE, UL, FCC, EMV-Klasse B'
          }]
        }
      }, {
        comboSubId: 'combo_1_sub_2',
        name: 'Batterie-Montagegurt',
        desc: 'Schließen Sie Ihre Batterie sicher an.',
        img: '/img/calculators/mm100/combo-strap.jpg',
        imgH5: '/img/calculators/mm100H5/combo-strap.jpg'
      }]
    }, {
      productId: 2,
      variantId: '',
      name: 'Fügen Sie mehr Leistung hinzu, steuern Sie Ihr System und überwachen Sie den Energieverbrauch.',
      discountPrice: 1600,
      originalPrice: 2355,
      unit: '€',
      subs: [{
        comboSubId: 'combo_2_sub_1',
        name: 'Intelligenter AC/DC-Verteilerkasten',
        desc: 'Mit 12 gesicherten DC-Anschlüssen und 6 AFCI-geschützten AC-Anschlüssen können Sie die Stromverteilung rund um Ihr Wohnmobil oder Tiny Haus verwalten. Steuern Sie bis zu 6 DC-Anschlüsse über die EcoFlow-App oder die Konsole.',
        img: '/img/calculators/mm100/combo-distribution.jpg',
        imgH5: '/img/calculators/mm100H5/combo-distribution.jpg',
        details: {
          title: 'Intelligenter AC/DC-Verteilerkasten',
          desc: 'Mit 12 gesicherten DC-Anschlüssen und 6 AFCI-geschützten AC-Anschlüssen können Sie die Stromverteilung rund um Ihr Wohnmobil oder Tiny Haus verwalten. Steuern Sie bis zu 6 DC-Anschlüsse über die EcoFlow-App oder die Konsole.',
          img: '/img/calculators/mm100/combo-detail-distribution.jpg',
          imgH5: '/img/calculators/mm100H5/combo-distribution.jpg',
          specParams: [{
            key: 'AC-Haupteingang',
            value: 'Max. 16 A, 230 V, 3600 W'
          }, {
            key: 'DC-Haupteingang',
            value: 'Max. 70 A'
          }, {
            key: 'AC-Ausgang',
            value: '6 AC-Anschlüsse, jeweils max. 10 A'
          }, {
            key: 'DC-Ausgang',
            value: '12 gesicherte DC-Anschlüsse (6 Anschlüsse über die Power Kit Konsole und App steuerbar)'
          }, {
            key: 'Betriebstemperatur',
            value: '-25°C to 60°C'
          }, {
            key: 'Abmessungen',
            value: '210 x 354 x 98 mm (Höhe x Breite x Tiefe)'
          }, {
            key: 'Nettogewicht',
            value: '2,6 kg'
          }, {
            key: 'Schutzart',
            value: 'IP21'
          }, {
            key: 'Tests und Zertifikationen',
            value: 'CE, UL, FCC, EMV-Klasse B'
          }]
        }
      }, {
        comboSubId: 'combo_2_sub_2',
        name: 'EcoFlow Power Kit Konsole',
        desc: 'Steuern, überwachen und visualisieren Sie Ihren Stromverbrauch.',
        img: '/img/calculators/mm100/combo-console.jpg',
        imgH5: '/img/calculators/mm100H5/combo-console.jpg',
        details: {
          title: 'EcoFlow Power Kit Konsole',
          desc: 'Steuern, überwachen und visualisieren Sie Ihren Stromverbrauch.',
          img: '/img/calculators/mm100/combo-detail-console.jpg',
          imgH5: '/img/calculators/mm100H5/combo-console.jpg',
          specParams: [{
            key: 'Touchscreen (Bildschirmdiagonale)',
            value: '7 Zoll (154,21 x 85,92 mm) (Breite x Höhe)'
          }, {
            key: 'Versorgungsspannung',
            value: '12 V DC'
          }, {
            key: 'Betriebstemperatur',
            value: '-25°C to 60°C'
          }, {
            key: 'Abmessungen',
            value: '113,3 x 204,5 x 22,35 mm (Höhe x Breite x Tiefe)'
          }, {
            key: 'Nettogewicht',
            value: '450 g'
          }, {
            key: 'Tests und Zertifikationen',
            value: 'UL, CE, FCC, EMV-Klasse B'
          }]
        }
      },
      // {
      //     comboSubId: 'combo_2_sub_3',
      //     name: 'Smart Generator',
      //     desc: 'In Notfällen können Sie den Smart Generator als Notstromversorgung verwenden. Er ist bis zu 25 % effizienter als andere Generatoren und verringert Kraftstoffverbrauch, Dämpfe und Zeitaufwand.',
      //     img: '/img/calculators/mm100/combo-generator.jpg',
      //     imgH5: '/img/calculators/mm100H5/combo-generator.jpg',
      //     details: {
      //         title: 'Smart Generator',
      //         desc: 'In Notfällen können Sie den Smart Generator als Notstromversorgung verwenden. Er ist bis zu 25 % effizienter als andere Generatoren und verringert Kraftstoffverbrauch, Dämpfe und Zeitaufwand.',
      //         img: '/img/calculators/mm100/combo-detail-generator.jpg',
      //         imgH5: '/img/calculators/mm100H5/combo-generator.jpg',
      //         specParams: [
      //             { key: 'Nettogewicht', value: '29,3 kg' },
      //             { key: 'Abmessungen', value: '59,7 x 29,6 x 47,5 cm' },
      //             { key: 'Nennspannung', value: '230 V' },
      //             { key: 'Typ', value: 'Wechselrichtergenerator' },
      //             { key: 'Frequenz', value: '50Hz / 60Hz' },
      //             { key: 'Nennausgangsleistung', value: '1800 W (Spitzenwert 1900 W)' },
      //             { key: 'Kraftstoffart', value: 'Bleifreies Benzin' },
      //             { key: 'Tankfüllmenge', value: '1,06 gal (4 l)' },
      //             { key: 'Kontinuierliche Betriebszeit', value: '3,5 h (Volllast)' },
      //         ]
      //     }
      // },
      {
        comboSubId: 'combo_2_sub_4',
        name: 'Batterie-Montagegurt',
        desc: 'Schließen Sie Ihre Batterie sicher an.',
        img: '/img/calculators/mm100/combo-strap.jpg',
        imgH5: '/img/calculators/mm100H5/combo-strap.jpg'
      }]
    }],
    // solar panel
    solarPack: [{
      productId: '7686916833527',
      variantId: '42952014758135',
      name: '2*100W Starres Solarpanel + 2*Montagefüße',
      discountPrice: 150.42,
      originalPrice: 192.44,
      // discountRate: 0.8,
      unit: '€',
      number: 0,
      capacity: 200,
      img: '/img/calculators/mm100/solar-100-rigid.jpg',
      imgH5: '/img/calculators/mm100H5/solar-100-rigid.jpg',
      // desc: 'Die neue handliche Action-Kamera hält deine Hände frei, damit du den Moment genießen kannst',
      details: {
        title: '2*100W Starres Solarpanel + 2*Montagefüße',
        desc: '',
        img: '/img/calculators/mm100/solar-detail-100-rigid.jpg',
        imgH5: '/img/calculators/mm100H5/solar-100-rigid.jpg',
        specParams: [{
          key: 'Nennleistung',
          value: '100 W (+/-5 W)'
        }, {
          key: 'Leerlaufspannung',
          value: '20,3 V'
        }, {
          key: 'Kurzschlussstrom',
          value: '6,3 A'
        }, {
          key: 'Maximale Betriebsspannung',
          value: '17,1 V'
        }, {
          key: 'Maximaler Betriebsstrom',
          value: '5,9 A'
        }, {
          key: 'Temperaturkoeffizient der Nennleistung',
          value: '-0,39%/°C'
        }, {
          key: 'Temperaturkoeffizient der Leerlaufspannung',
          value: '-0,33%/°C'
        }, {
          key: 'Temperaturkoeffizient des Kurzschlussstroms',
          value: '0,06%/°C'
        }, {
          key: 'Maximaler Sicherungsstrom',
          value: '600 V DC (UL)'
        }, {
          key: 'Maximum Fuse Current',
          value: '15 A'
        }, {
          key: 'Gewicht Solarpanel',
          value: 'ca. 6,2 kg (13,7 lbs)'
        }, {
          key: 'Abmessungen',
          value: '98 x 58,6 x 3 cm'
        }]
      },
      question: {}
    }, {
      productId: '7686916866295',
      variantId: '42952014790903',
      name: '2*400W Starres Solarpanel + 4*Montagefüße',
      discountPrice: 503.36,
      originalPrice: 671.43,
      // discountRate: 0.8,
      unit: '€',
      number: 0,
      capacity: 800,
      // freeShip: 1,
      img: '/img/calculators/mm100/solar-400-rigid.jpg',
      imgH5: '/img/calculators/mm100H5/solar-400-rigid.jpg',
      // desc: 'Die neue handliche Action-Kamera hält deine Hände frei, damit du den Moment genießen kannst',
      details: {
        title: '2*400W Starres Solarpanel + 4*Montagefüße',
        img: '/img/calculators/mm100/solar-detail-400-rigid.jpg',
        imgH5: '/img/calculators/mm100H5/solar-400-rigid.jpg',
        specParams: [{
          key: 'Nennleistung',
          value: '400 W (+/-3 W)'
        }, {
          key: 'Leerlaufspannung',
          value: '37,1 V'
        }, {
          key: 'Kurzschlussstrom',
          value: '13,79 A'
        }, {
          key: 'Maximale Betriebsspannung',
          value: '31,00 V'
        }, {
          key: 'Maximaler Betriebsstrom',
          value: '12,90 A'
        }, {
          key: 'Temperaturkoeffizient der Nennleistung',
          value: '-0,38 %/°C'
        }, {
          key: 'Temperaturkoeffizient der Leerlaufspannung',
          value: '-0,35 %/°C'
        }, {
          key: 'Temperaturkoeffizient des Kurzschlussstroms',
          value: '+0,06 %/°C'
        }, {
          key: 'Maximale Systemspannung',
          value: '1500 V DC'
        }, {
          key: 'Maximaler Sicherungsstrom',
          value: '25 A'
        }, {
          key: 'Betriebstemperatur',
          value: '-25°C- +50°C'
        }, {
          key: 'Gewicht Solarpanel',
          value: 'ca. 21,8 kg'
        }, {
          key: 'Abmessungen',
          value: '1722 x 1134 x 35 mm'
        }]
      },
      question: {}
    }, {
      productId: '7686916931831',
      variantId: '42952014823671',
      name: '1*100W Flexibles Solarpanel',
      discountPrice: 129,
      originalPrice: 149,
      // discountRate: 0.8,
      unit: '€',
      number: 0,
      capacity: 100,
      img: '/img/calculators/mm100/solar-100-flexible.jpg',
      imgH5: '/img/calculators/mm100H5/solar-100-flexible.jpg',
      // desc: 'Die neue handliche Action-Kamera hält deine Hände frei, damit du den Moment genießen kannst',
      details: {
        title: '1*100W Flexibles Solarpanel',
        desc: '',
        img: '/img/calculators/mm100/solar-detail-100-flexible.jpg',
        imgH5: '/img/calculators/mm100H5/solar-100-flexible.jpg',
        specParams: [{
          key: 'Nennleistung',
          value: '100 W (+/- 5 W)'
        }, {
          key: 'Leerlaufspannung',
          value: '20,3 V'
        }, {
          key: 'Kurzschlussstrom',
          value: '6,3 A'
        }, {
          key: 'Maximale Betriebsspannung',
          value: '17,1 V'
        }, {
          key: 'Maximaler Betriebsstrom',
          value: '5,9 A'
        }, {
          key: 'Temperaturkoeffizient der Nennleistung',
          value: '-0,39%/°C'
        }, {
          key: 'Temperaturkoeffizient der Leerlaufspannung',
          value: '-0,33%/°C'
        }, {
          key: 'Temperaturkoeffizient des Kurzschlussstroms',
          value: '0,06%/°C'
        }, {
          key: 'Maximale Systemspannung',
          value: '600 V DC (UL)'
        }, {
          key: 'Maximaler Sicherungsstrom',
          value: '15 A'
        }, {
          key: 'Gewicht Solarpanel',
          value: 'ca. 2,3 kg (5,1 lbs)'
        }, {
          key: 'Abmessungen',
          value: '1055 x 612 x 25 mm'
        }]
      },
      question: {}
    }, {
      productId: '6618094960713',
      variantId: '39998021697609',
      name: '1*400W Portable Solar Panel',
      discountPrice: 1199,
      originalPrice: 1199,
      // discountRate: 0.8,
      unit: '€',
      number: 0,
      capacity: 400,
      locale: ['us', 'ca', 'au', 'jp'],
      // only for us site
      img: '/img/calculators/mm100/solar-400-portable.jpg',
      imgH5: '/img/calculators/mm100H5/solar-400-portable.jpg',
      // desc: 'Die neue handliche Action-Kamera hält deine Hände frei, damit du den Moment genießen kannst',
      details: {
        title: '1*400W Portable Solar Panel',
        desc: '',
        img: '/img/calculators/mm100/solar-detail-400-portable.jpg',
        imgH5: '/img/calculators/mm100H5/solar-400-portable.jpg',
        specParams: [{
          key: 'Rated Power',
          value: '400W(+/-10W)'
        }, {
          key: 'Open Circuit Voltage',
          value: '48V(Vmp 41V)'
        }, {
          key: 'Short Circuit Current',
          value: '11A(Imp 9.8A)'
        }, {
          key: 'Efficiency',
          value: '22.4 %'
        }, {
          key: 'Cell Type',
          value: 'Monocrystalline silicon'
        }, {
          key: 'Connector type',
          value: 'MC4'
        }, {
          key: 'Weight',
          value: '46.3 lbs(21.0KG)'
        }, {
          key: 'Solar Panel',
          value: '33.1lbs(15.0KG)'
        }, {
          key: 'Unfolded Dimensions',
          value: '42.0 * 94.1 * 1.0 in (106.8 * 239.0 * 2.4cm)'
        }, {
          key: 'Folded Dimensions',
          value: '42.0 * 24.4 * 1.0 in (106.8 * 62.0 * 2.4cm)'
        }]
      },
      question: {}
    }],
    // bundle imgs when choose the bundle (left main image)  - variant_id
    bundleImgs: {
      42952013349111: 'power-2kw.jpg',
      42952013381879: 'bundle-2kw-dp.jpg',
      42952013414647: 'bundle-2kw-all_us.jpg',
      42952013447415: 'power-4kw.jpg',
      42952013480183: 'bundle-4kw-dp.jpg',
      42952013512951: 'bundle-4kw-all_us.jpg',
      42952013545719: 'power-5kw.jpg',
      42952013578487: 'bundle-5kw-dp.jpg',
      42952013611255: 'bundle-5kw-all_us.jpg',
      42952013644023: 'power-10kw.jpg',
      42952013676791: 'bundle-10kw-dp.jpg',
      42952013709559: 'bundle-10kw-all_us.jpg',
      42952014594295: 'power-15kw.jpg',
      42952014627063: 'bundle-15kw-dp.jpg',
      42952014659831: 'bundle-15kw-all_us.jpg'
    },
    // solar price discount rate
    // solarDiscountRate: {
    //     // product_id
    //     '6757458116681': {
    //         '0': 0.92,
    //         '1': 0.87,
    //         '2': 0.85,
    //     },
    //     '6757463720009': {
    //         '0': 0.87,
    //         '1': 0.84,
    //         '2': 0.82,
    //     },
    //     '6757464277065': {
    //         '0': 0.89,
    //         '1': 0.85,
    //         '2': 0.85,
    //     },
    //     '6757469388873': {
    //         '0': 0.87,
    //         '1': 0.85,
    //         '2': 0.8,
    //     },
    //     '6757470011465': {
    //         '0': 0.89,
    //         '1': 0.85,
    //         '2': 0.82,
    //     },
    // },

    // combo's original price under the bundle
    comboPrice: {
      // productId
      7686916538615: {
        original: [0, 570, 900],
        discount: [0, 500, 800]
      },
      7686916571383: {
        original: [0, 570, 900],
        discount: [0, 500, 800]
      },
      7686916604151: {
        original: [0, 570, 900],
        discount: [0, 500, 800]
      },
      7686916669687: {
        original: [0, 570, 900],
        discount: [0, 500, 800]
      },
      7686916735223: {
        original: [0, 570, 900],
        discount: [0, 500, 800]
      }
    },
    // common power kit's details
    powerDetails: {
      title: 'EcoFlow Power Hub ',
      img: '/img/calculators/mm100/defaultDetail.jpg',
      desc: 'Der Power Hub ist das Herzstück Ihres Power Kits und spart wertvollen Platz in Ihrem Wohnmobil oder netzunabhängigem Heim. Der Power Hub erfüllt die Aufgabe von zwei MPPT-Solarladereglern, einem Batterieladegerät mit MPPT, einem DC/DC-Abwärtswandler und einem Wechselrichter-Ladegerät – alles in einem Gerät.',
      specParams: [{
        key: 'Nettogewicht',
        value: '14 kg'
      }, {
        key: 'Abmessungen',
        value: '30 x 48 x 14 cm (Höhe x Breite x Tiefe)'
      }, {
        key: 'Tests und Zertifikationen',
        value: 'CE, UL, FCC'
      }, {
        key: 'WLAN',
        value: 'Unterstützt'
      }, {
        key: 'Bluetooth',
        value: 'Unterstützt'
      }, {
        key: 'AC-Hauptausgang/Frequenz',
        value: 'Reine Sinuswelle, 3600 W (Spitze 6000 W), 230 V, 50/60 Hz'
      }, {
        key: 'DC-Hauptausgang',
        value: '13,6 V/70 A max. 1000 W; 26,4 V/60 A max. 1500 W'
      }, {
        key: 'AC-Haupteingang',
        value: 'X-Stream-Schnellladung max. 3000 W, max. 16 A'
      }, {
        key: 'AC-Haupteingangsspannung/Frequenz',
        value: '200-240 V, 50/60 Hz'
      }, {
        key: 'Solarladeeingang',
        value: '15-150 V, 30 A, max. 1600 W'
      }, {
        key: 'Generator-Ladeeingang',
        value: '13-60 V, 60 A, max. 1000 W'
      }, {
        key: 'Optimale Betriebstemperatur',
        value: '20°C-30°C'
      }, {
        key: 'Entladetemperatur',
        value: '-25°C-60°C'
      }, {
        key: 'Ladetemperatur',
        value: '-25°C-60°C'
      }, {
        key: 'Lagertemperatur',
        value: '-25°C-60°C'
      }]
    },
    // common solar panel's questions
    solarQuestion: {
      text: 'Die erhöhte Laufzeit wurde basierend auf einer durchschnittlichen Solarpanel-Eingangsleistung von 80 % und 5 Stunden Sonneneinstrahlung berechnet.'
    },
    // installations
    // installOptions: [
    //     {
    //         variantId: 0,
    //         i18n: 'self',
    //     },
    //     {
    //         productId: '7686916964599',
    //         variantId: '42952014856439',
    //         i18n: 'expert',
    //         i18n_des: 'pro',
    //     },
    // ],

    // tax price tag
    taxPriceTag: {
      jp: '(税込)'
    },
    isPriveReverseFlag: true,
    wire: {
      name: 'Kabelpaket + Batterie-Montagegurt'
    },
    installTerms: {
      title: 'Free Installation Terms and Conditions*',
      text: '1. Orders placed between 2022.08.25 to 2022.09.30 will be qualified for this limited-time offer. \n2. For addresses within the EcoFlow installer network, EcoFlow would contact you to make an appointment for free installation service. \n3. For addresses outside the EcoFlow installer network, customers can choose local installers. EcoFlow will reimburse the installation cost of Power Kits products.',
      sup: '*EcoFlow reserves the rights of final interpretation.'
    }
  };
};